import React from "react";
// @ts-ignore
import {Link} from "react-router-dom";
import {BackCaret} from "../styledComponents/CustomStyledComponents";

interface BackProps {
    backRoute:  string,
    label?: string,
    customStyle?: {},
    inverted?: boolean,
    backColor?: string
}

const BackComponent: React.FC<BackProps> = ({backRoute, label = 'Atrás', customStyle= {}, inverted = false, backColor = '#B3001E'}) => {

    return(
        <Link
          style={{
            display: 'flex',
            color: backColor,
            flexDirection: inverted ? 'row-reverse':'row',
            ...customStyle,
          }}
          to={backRoute}
        >
            <div style={{color: backColor, fontFamily: 'Mapfre-Light', fontSize: 20}}> { label } </div>
            <BackCaret backColor={backColor}/>
        </Link>
    )
};

export default BackComponent;
